<template>
  <div class="z1">
    <footer>
      <div class="container-fluid">
        <div class="row d-flex justify-content-center align-items-center pt-3">
          <div class="col-12 text-center">
            
          </div>
        </div>
      </div>
    </footer>

   

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

